<div class="d-flex flex-wrap" style="flex-direction: column">
  <div style="height: 65px; position: sticky; top: 0px; background-color: #fff">
    <div class="d-flex flex-wrap">
      <div class="flex-grow-1">
        <div style="padding-left: 8px; padding-right: 8px">
          <div class="md-inputfield" style="position: relative">
            <input
              id="orgNameInput"
              #orgNameInput
              autofocus
              (ngModelChange)="searchTextChanged($event)"
              [ngModel]="searchText"
              autocomplete="off"
              class="search-box"
              name="orgName"
              pInputText
              placeholder="Search Supplier or Customer"
              spellcheck="false"
              type="text"
              style="width: 100%"
            />
            <span class="fa fa-search search-icon"></span>
          </div>
        </div>
      </div>
      <div class="flex-shrink-1">
        <div class="px-2">
          <p-dropdown
            [options]="orgTypeOptions"
            (ngModelChange)="orgTypeChange($event)"
            [ngModel]="orgType"
            styleClass="engineius-dropdown"
            appendTo="body"
          ></p-dropdown>
        </div>
      </div>
      <div class="flex-shrink-1">
        <div class="px-2">
          <p-dropdown
            [options]="orgStatusOptions"
            (ngModelChange)="orgStatusChange($event)"
            [ngModel]="orgStatus"
            styleClass="engineius-dropdown"
            appendTo="body"
          ></p-dropdown>
        </div>
      </div>
    </div>
  </div>

  <div style="color: rgb(51, 51, 51); flex-grow: 1; overflow-y: auto; max-height: 400px">
    <div class="px-2">
      <table class="organisation-view" style="width: 100%; font-size: 0.8rem">
        <thead>
          <tr>
            <th style="text-align: left">Organisation</th>
            <th style="text-align: left">Contact Details</th>
            <th style="text-align: left">Org. Type</th>
            <th style="text-align: left">Status</th>
            <th style="text-align: left"># of Users</th>
          </tr>
        </thead>
        <tbody>
          <tr
            (click)="organisationSelected(org, i)"
            *ngFor="let org of organisationInfos; let i = index"
            [ngClass]="{ 'selected-row': selectedRow === i }"
          >
            <td style="text-align: left">
              <div style="font-weight: bold">{{ org.name }}</div>
              <div class="sub-row">{{ org.addressLine1 }} {{ org.town }} {{ org.postcode }}</div>
            </td>
            <td>
              <div class="sub-row"><i class="fa fa-envelope"></i> {{ org.emailAddress }}</div>
              <div class="sub-row"><i class="fa fa-phone"></i> {{ org.phoneNumber }}</div>
              <div
                class="sub-row"
                *ngFor="let phone of org.organisationPhoneNumbers; let idx = index"
              >
                <div *ngIf="idx == 0">
                  <i class="fa fa-phone"></i> {{ phone.phoneNumber }}
                  <span
                    *ngIf="org.organisationPhoneNumbers?.length > 1"
                    (mouseover)="hoverMore = org.id"
                    (mouseout)="hoverMore = null"
                    >+ {{ org.organisationPhoneNumbers.length - 1 }} more</span
                  >
                </div>

                <span
                  *ngIf="org.organisationPhoneNumbers && org.organisationPhoneNumbers.length > 1"
                >
                  <div *ngIf="idx > 0 && hoverMore == org.id">
                    <i class="fa fa-phone-square"></i> {{ phone.phoneNumber }}
                  </div>
                </span>
              </div>
            </td>
            <td>
              <span>{{ org.organisationTypeName }}</span>
            </td>
            <td class="org-inactive-{{ org.inactive }}">
              <span class="bull-status">&bull;</span>
              <span class="org-status">{{ orgStatusName[org.inactive] }}</span>
            </td>
            <td>{{ org.users?.length }} User{{ org.users?.length > 1 ? 's' : '' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
